import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"
import TextField from "../../../Utils/TextField"
import DropdownField from "../../../Utils/DropdownField"
import { countries, states } from "../../../Types/countries"
import styles from "../../../../../styles/Participant-Employment.module.css"
import CalendarField from "../../../Utils/CalendarField"
import RadioButtonField from "../../../Utils/RadioButtonField"
import EditorField from "../../../Utils/EditorField"
import { useFormik } from "formik"
import { getFormErrorMessage } from "../../../Utils/formikAux"
import { useEffect } from "react"

const EducationForm = ({
  visible,
  setVisible,
  edit,
  setValue,
  programs,
  setEdit,
}) => {
  const { v4: uuidv4 } = require("uuid")
  const formik = useFormik({
    initialValues: {
      name: "",
      country: "US",
      city: "",
      state: "",
      startDate: undefined,
      endDate: undefined,
      typeOfDegree: "",
      complete: "",
      whyNotComplete: "",
      likeMostProgram: "",
      likeLeastProgram: "",
      financialAid: "",
      typeOfFinancialAid: "",
      degrees: "",
    },
    validate: (data) => {
      let errors = {}
      if (!data.country) {
        errors.country = "Country is required"
      }
      if (!data.city) {
        errors.city = "City is required"
      }
      if (!data.state && data.country === "US") {
        errors.state = "State is required"
      }
      if (data.endDate && data.startDate) {
        if (data.endDate < data.startDate) {
          errors.endDate = "Start date can not be greater than End date"
        }
      }
      return errors
    },
    onSubmit: (data) => {
      data && saveEducationProgram(data)
      formik.resetForm()
      setVisible(false)
    },
  })
  useEffect(() => {
    if (edit) {
      formik.setValues({
        name: edit?.name,
        country: edit?.country,
        city: edit?.city,
        state: edit?.state,
        startDate: edit?.startDate ? new Date(edit?.startDate) : undefined,
        endDate: edit?.endDate ? new Date(edit?.endDate) : undefined,
        typeOfDegree: edit?.typeOfDegree,
        complete: edit?.complete,
        whyNotComplete: edit?.whyNotComplte,
        likeMostProgram: edit?.likeMostProgram,
        likeLeastProgram: edit?.likeLeastProgram,
        financialAid: edit?.financialAid,
        typeOfFinancialAid: edit?.typeOfFinancialAid,
        degrees: edit?.degrees,
        id: edit?.id,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit])

  const footer = () => {
    return (
      <div className={styles.education_form_footer}>
        <Button
          label="Cancel"
          type="button"
          onClick={() => {
            formik.resetForm()
            formik.setErrors({})
            setEdit(null)
            setVisible(false)
          }}
          className={`${styles.button} ${styles.button_secondary}`}
        />
        <Button
          label={`${edit ? "Edit" : "Create"} education`}
          type="submit"
          style={{ marginLeft: "1rem" }}
          className={`${styles.button}`}
        />
      </div>
    )
  }
  const saveEducationProgram = (program) => {
    const prog = { ...program, id: uuidv4(), new: true }
    if (edit) {
      const newSave = programs?.map((s) => {
        let newValue = { ...s }
        if (s.id === edit?.id) {
          newValue.name = prog.name
          newValue.country = prog.country
          newValue.city = prog.city
          newValue.state = prog.state
          newValue.startDate = prog.startDate
          newValue.endDate = prog.endDate
          newValue.typeOfDegree = prog.typeOfDegree
          newValue.complete = prog.complete
          newValue.whyNotComplete = prog.whyNotComplete
          newValue.likeMostProgram = prog.likeMostProgram
          newValue.likeLeastProgram = prog.likeLeastProgram
          newValue.financialAid = prog.financialAid
          newValue.typeOfFinancialAid = prog.typeOfFinancialAid
          newValue.degrees = prog.degrees
          newValue.modified = true
        }
        return newValue
      })
      setValue("educationPrograms", newSave)
      setEdit(null)
    } else {
      const oldPrograms = [...programs]
      oldPrograms.push(prog)
      setValue("educationPrograms", oldPrograms)
    }
  }
  const header = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "solid 3px #e7e0f1",
          marginBottom: "20px",
        }}
      >
        <p
          style={{
            fontSize: "24px",
            fontWeight: "700",
            lineHeight: "33px",
            marginBottom: "20px",
            marginTop: "10px",
          }}
        >{`${edit ? "Edit" : "Add"} education`}</p>
        <Button
          className={styles.rounded_btn}
          icon="pi pi-times"
          type="submit"
          onClick={() => {
            formik.resetForm()
            setEdit(null)
            setVisible(false)
          }}
          style={{ marginTop: "10px" }}
        />
      </div>
    )
  }
  return (
    <Dialog
      showHeader={false}
      visible={visible}
      style={{ width: "50vw" }}
      onHide={() => {
        formik.resetForm()
        formik.setErrors({})
        setEdit(null)
        setVisible(false)
      }}
    >
      {header()}
      <form onSubmit={formik.handleSubmit}>
        <TextField
          label={"Name of educational/training institution"}
          value={formik.values.name}
          setValue={formik.setFieldValue}
          valueName={"name"}
          error={getFormErrorMessage("name", formik)}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            gap: "10px",
            marginBottom: "20px",
            marginTop: "10px",
          }}
        >
          <DropdownField
            label={"Country"}
            options={countries}
            value={formik.values.country}
            setValue={formik.setFieldValue}
            valueName={"country"}
            error={getFormErrorMessage("country", formik)}
            required
            size={"32"}
            filter
            callback={() => {
              formik.setFieldValue("state", "")
            }}
          />
          <TextField
            label={"City"}
            value={formik.values.city}
            setValue={formik.setFieldValue}
            valueName={"city"}
            error={getFormErrorMessage("city", formik)}
            required
            size={"33"}
          />
          {formik.values.country === "US" && (
            <DropdownField
              label={"State"}
              options={states}
              value={formik.values.state}
              setValue={formik.setFieldValue}
              valueName={"state"}
              error={getFormErrorMessage("state", formik)}
              required
              size={"32"}
            />
          )}
        </div>
        <label className={styles.view_subtitle}>Years attended</label>
        <hr className={styles.line} style={{ marginTop: "10px" }}></hr>
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            gap: "10px",
          }}
        >
          <CalendarField
            label={"Start date"}
            value={formik.values.startDate}
            setValue={formik.setFieldValue}
            valueName={"startDate"}
            error={getFormErrorMessage("endDate", formik)}
            size={"50"}
            showErrorMessage
            maxValue={formik.values.endDate}
          />
          <CalendarField
            label={"End date"}
            value={formik.values.endDate}
            setValue={formik.setFieldValue}
            valueName={"endDate"}
            error={getFormErrorMessage("endDate", formik)}
            size={"50"}
            minValue={formik.values.startDate}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            gap: "10px",
            marginTop: "10px",
          }}
        >
          <TextField
            label={"Type of degree or certificate sought"}
            value={formik.values.typeOfDegree}
            setValue={formik.setFieldValue}
            valueName={"typeOfDegree"}
            error={getFormErrorMessage("typeOfDegree", formik)}
            size={"50"}
          />
          <RadioButtonField
            short
            label={"Did you complete the program?"}
            value={formik.values.complete}
            setValue={formik.setFieldValue}
            valueName={"complete"}
            error={getFormErrorMessage("complete", formik)}
          />
        </div>
        {formik.values.complete === "No" && (
          <div style={{ marginTop: "13px" }}>
            <EditorField
              label={"Why did you not complete the program?"}
              onTextChange={formik.setFieldValue}
              value={formik.values.whyNotComplete}
              valueName={"whyNotComplete"}
              error={getFormErrorMessage("whyNotComplete", formik)}
            />
          </div>
        )}
        <div style={{ marginTop: "13px" }}>
          <EditorField
            label={"What did you like most about the program?"}
            onTextChange={formik.setFieldValue}
            value={formik.values.likeMostProgram}
            valueName={"likeMostProgram"}
            error={getFormErrorMessage("likeMostProgram", formik)}
          />
        </div>
        <div style={{ marginTop: "30px" }}>
          <EditorField
            label={"What did you like least about the program?"}
            onTextChange={formik.setFieldValue}
            value={formik.values.likeLeastProgram}
            valueName={"likeLeastProgram"}
            error={getFormErrorMessage("likeLeastProgram", formik)}
          />
        </div>
        <div style={{ marginTop: "30px" }}>
          <RadioButtonField
            short
            label={"Did you use financial aid in the program?"}
            value={formik.values.financialAid}
            setValue={formik.setFieldValue}
            valueName={"financialAid"}
            error={getFormErrorMessage("financialAid", formik)}
          />
        </div>
        {formik.values.financialAid === "Yes" && (
          <div style={{ marginTop: "30px" }}>
            <EditorField
              label={"What type of financial aid did you use?"}
              onTextChange={formik.setFieldValue}
              value={formik.values.typeOfFinancialAid}
              valueName={"likeLeastProgram"}
              error={getFormErrorMessage("likeLeastProgram", formik)}
            />
          </div>
        )}
        <div style={{ marginTop: "30px" }}>
          <EditorField
            label={"Degrees, certificates, or classes completed"}
            onTextChange={formik.setFieldValue}
            value={formik.values.degrees}
            valueName={"degrees"}
            error={getFormErrorMessage("degrees", formik)}
          />
        </div>
        {footer()}
      </form>
    </Dialog>
  )
}
export default EducationForm
